import type { Correlations } from "@/composables/forms/formTypes";
import type {
  BasicData,
  GasProperties
} from "@/libs/calculations/fluidProperties/d";
import { Kelvin, Rankine } from "@/libs/units/temperature";
import { API } from "@/libs/units/density";
import type { GasVolumeCompressibilityParameters } from "./d";
import type { PsuedoCriticalCalculations } from "./psuedo-criticals";

export function buildParams(
  basicData: BasicData,
  correlations: Correlations,
  psuedoCriticals: PsuedoCriticalCalculations,
  inSituPressurePSIA: number,
  temperatureF: number,
  gasProperties: GasProperties[],
  oilDensityLBMFT3?: number
): GasVolumeCompressibilityParameters {
  const temperatureInRankine = Rankine.toThisUnit(temperatureF);
  const temperatureKelvin = Kelvin.toThisUnit(temperatureF);
  const tubingPressurePSIA = basicData.bottomTubingPressurePSIA;
  const reservoirPressurePSIA = basicData.staticBottomholePressurePSIA;
  const surfaceTemperatureF = basicData.surfaceTemperatureF;
  const oilAPI = basicData.oilAPI;
  const oilSpecificGravity = API.toStandardUnit(oilAPI);
  const gasSpecificGravity = basicData.gasSpecificGravity;

  return {
    gasSpecificGravity,
    psuedoCriticals,
    oilAPI,
    surfaceTemperatureF,
    tubingPressurePSIA,
    reservoirPressurePSIA,
    temperatureInRankine,
    temperatureKelvin,
    inSituPressurePSIA,
    oilSpecificGravity,
    temperatureF,
    gasPercentages: basicData.gasPercentages,
    oilDensityLBMFT3,
    gasProperties,
    sourceParams: {
      basicData,
      correlations,
      inSituPressurePSIA,
      temperatureF
    }
  };
}
